import * as React from 'react';
import { styled } from '@mui/material/styles';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { Box } from '@mui/material';

// Styled Step acting like a connector bar
const MobileStep = styled(Step, {
  shouldForwardProp: (prop) => prop !== 'color',
})(({ theme, color }) => ({
  boxSizing: 'border-box', // ✅ Add this line
  padding: 0,
  flex: 1,
  minWidth: 0,
  position: 'relative',
  height: 6 , // Height of the connector bar
  backgroundColor: color,
  margin: '0 1px', // Slight spacing between bars
  borderRadius: 4,
  '& .MuiStepLabel-root': {
    padding: 0,
  },
    border:"1px solid black"
}));

export function MobileStepper({
  activeStep,
  steps,
  completedSteps = [],
  skippedSteps = [],
}) {
  return (
    <Box sx={{ width: '100%', overflow: 'visible' }}>
    <Stepper
      activeStep={activeStep}
      alternativeLabel={false}
      connector={null} // 🔥 This disables the default connector
      sx={{
        width: '100%',
      p:0,
        m: 0,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        height: 8,
      
      }}
    >
      {steps.map((_, index) => {
        let color = '#1c2230'; // default (pending)
        if (index === activeStep) color = '#897EFF'; // purple for active
        else if (completedSteps.includes(index)) color = '#4EC749'; // green
        else if (skippedSteps.includes(index)) color = '#FFBB33'; // yellow

        return (
          <MobileStep
            key={index}
            color={color}
          >
            <StepLabel sx={{ display: 'none !important' }} />
          </MobileStep>
        );
      })}
    </Stepper>
    </Box>
  );
}















